export const ToTime = (time: string) => {
    switch (time) {
        case "0":
            return "Zbývá několik sekund";
        case "1":
            return `Zbývá ${time} minuta`;
        case "2":
        case "3":
        case "4":
            return `Zbývají ${time} minuty`;
        default:
            return  `Zbývá ${time} minut`;
    }
}

